/**
 * Manages user settings api interactions
 *
 * Copyright (c) 2019 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import axios from 'axios'
import apiConfig from 'common/configs/api'
import { getHeaders } from '../../auth/api'

const { apiUrl, users } = apiConfig
const { settings } = users
const usersUrl = `${apiUrl}${users.url}`

export const updateAccountSettings = (userId, data) => {
  const accountSettingsUrl = `${usersUrl}/${userId}${settings.url}${settings.account}`
  const headers = getHeaders()

  return axios.patch(accountSettingsUrl, data, { headers })
}
